import styled, { css, keyframes } from 'styled-components'

const showModal = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  transition: background 0.2s;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  animation: ${showModal} 400ms;
`

export const ModalWrapper = styled.div`
  max-width: 500px;
  padding: 32px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  position: relative;
  text-align: left;
  overflow: auto;
  max-height: 95%;

  z-index: 10;
  border-radius: 4px;

  @media (max-width: 560px) {
    max-width: 90%;
    margin: auto;
  }

  @media (max-height: 630px) {
    max-height: 95%;
    overflow-y: auto;
  }
`

export const ContentWrapper = styled.div`
  h3 {
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 24px;
  }

  .content {
    overflow-y: auto;
    /* height: calc(110px + (600 — 110) * ((70vh — 210px) / (1080 — 110))); */
  }

  p.title {
    margin-bottom: 8px;
    font-weight: 600;
  }

  @media (max-height: 630px) {
    max-height: 95%;

    .content {
      overflow-y: auto;
      height: 40vh;
    }
  }
`

export const CardWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;

    .col-6 {
      width: 100%;
    }
  `}
`

export const ProfileBoxFooter = styled.div`
  display: flex;
  padding: 0;
  align-items: center;
  margin-top: 8px;

  @media (max-width: 600px) {
    flex-direction: column;

    button,
    button.button-outline {
      max-width: 100%;
      margin-right: 0;
    }
  }
`

export const Button = styled.button`
  ${({ theme }) => css`
    /* max-width: 170px; */

    border-radius: 4px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    padding: 16px 30px;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.cart};
    color: ${theme.colors.white};

    &:hover {
      background: #33a161;
    }

    & + .button {
      margin-left: 15px;
    }

    @media (max-width: ${theme.media.cel}) {
      font-size: 14px;
    }

    &.button-outline {
      max-width: 146px;
      background: transparent;
      border: 2px solid #8f8f8f;
      color: #8f8f8f;

      &:hover {
        border-color: #4a4a4a;
        color: #4a4a4a;
      }

      &:disabled {
        color: #7b7b7b;
        border-color: #7b7b7b;
        cursor: initial;
      }
    }

    @media (max-width: 1170px) {
      & + .button {
        margin-left: 0;
        margin-top: 8px;
      }
    }
  `}
`

export const HeaderModalClose = styled.button`
  background: none;
  border: 0;
  position: absolute;
  top: 38px;
  right: 32px;
  transition: all 400ms;
  cursor: pointer;

  img {
    width: 18px;
  }

  &:hover {
    opacity: 0.6;
  }
`
